module.exports = __webpack_public_path__ + "img/people-43-min.3b333a78.png";